var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 18.3333H12.5013C16.668 18.3333 18.3346 16.6667 18.3346 12.5V7.5C18.3346 3.33333 16.668 1.66667 12.5013 1.66667H7.5013C3.33464 1.66667 1.66797 3.33333 1.66797 7.5V12.5C1.66797 16.6667 3.33464 18.3333 7.5013 18.3333Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 12.075L8.09271 9.5C8.37604 9.13333 8.90104 9.06667 9.26771 9.35L10.7927 10.55C11.1594 10.8333 11.6844 10.7667 11.9677 10.4083L13.8927 7.925",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.9b2109eebe44e311f970851416130c64.svg";
export { ForwardRef as ReactComponent };